import YoutubeLogo from '../ui/assets/youtube.png';
import TwitchLogo from '../ui/assets/twitch.png';
import TrovoLogo from '../ui/assets/trovo.png';
import VKPlayLiveLogo from '../ui/assets/vk-play-live.png';
import { Link, SocialLink } from './types';


export const SOCIAL_LINKS: SocialLink[] = [
    {
        title: 'Twitch',
        link: 'https://www.twitch.tv/lestakorabli',
        img: TwitchLogo,
    },
    {
        title: 'Trovo',
        link: 'https://trovo.live/s/LestaKorabli',
        img: TrovoLogo,
    },
    {
        title: 'VK Видео Live',
        link: 'https://live.vkvideo.ru/category/1051291f-43d9-4490-81bc-aca8d53c8dfd',
        img: VKPlayLiveLogo,
    }
];

export const LEGAL_LINKS: Link[] = [
    {
        title: 'footer.legal.privacy',
        link: 'https://legal.lesta.ru/privacy-policy/',
    },
    {
        title: 'footer.legal.eula',
        link: 'https://legal.lesta.ru/eula/',
    },
    {
        title: 'footer.legal.partners',
        link: 'https://korabli.su/ru/content/offers/for-partners/',
    }
];
